import { ValidationError } from 'yup';

import {
  DocumentAnalysisModelEnum,
  DocumentDataSettingsModel,
} from '../../../../shared/models';
import yup from '../../../../utils/yup-extended';
import { MAX_FILE_PER_DOCUMENT_DATA } from '../constants';
import { getDocumentAnalysisDefinition } from '../document-analysis';
import { DocumentCheckInput } from '../document-check-input';
import { fraudAnalysisSettingsSchema } from '../fraud-analysis';

export const documentSettingsSchema = (): yup.SchemaOf<
  Omit<DocumentDataSettingsModel, 'customDocumentType'>
> => {
  return yup
    .object()
    .shape({
      documentTypeKey: yup
        .string()
        // Existence of the document type and availability to the check entity is validated
        // in during the check creation in the service
        .required(),
      documentAnalysis: yup
        .object()
        .shape({
          automaticApproval: yup.boolean().default(false).optional(),
          automaticRejection: yup.boolean().default(false).optional(),
          parameters: yup
            .mixed()
            .when('$model', (model: DocumentAnalysisModelEnum, schema) => {
              if (model) {
                const definition = getDocumentAnalysisDefinition(model);

                if (!definition) {
                  throw new ValidationError(`model=${model} does not exist`);
                }

                return schema.concat(definition.validationSchemas.parameters);
              }
              return schema;
            }),
        })
        .default(null)
        .nullable(),
      fraudAnalysis: fraudAnalysisSettingsSchema()
        .optional()
        .nullable()
        .default(null),
    })
    .noUnknown()
    .defined();
};

export const documentDataSchema = (): yup.SchemaOf<
  Required<DocumentCheckInput['data']>
> => {
  return yup
    .object({
      files: yup
        .array(yup.object({ uploadRef: yup.string().required() }))
        .uniqueItems((i) => i.uploadRef)
        .strict()
        .max(MAX_FILE_PER_DOCUMENT_DATA)
        .required(),
    })
    .noUnknown()
    .defined();
};
